import { axios } from '~/plugins/axios'

const actions = {
  async loadReports({ commit }) {
    return await axios.get('/api/dynamic-reports/get-list')
      .then(resp => {
        return resp.data;
      }).catch(err => console.log(err));
  },

  async loadElements({ commit }, reportIdentifier) {
    return await axios.get(`/api/dynamic-reports/${reportIdentifier}/elements`)
      .then(resp => {
        return resp.data;
      }).catch(err => console.log(err));
  },

  async loadDynamicData({ commit }, { url, method, data, headers = {} }) {
    const { responseType, ...restHeaders } = headers

    return await axios({
      url,
      method,
      [method === 'get' ? 'params' : 'data']: data,
      headers: restHeaders,
      ...(responseType != null ? { responseType } : {}),
    })
      .then(resp => {
        return resp;
      }).catch(err => console.log(err));
  },
}

export default {
  namespaced: true,
  actions,
}